import styled from 'styled-components';

export const TimerContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;
